// extracted by mini-css-extract-plugin
export default {"input":"DocumentUpload__input--1ii32"};